import domReady from '@wordpress/dom-ready';

domReady(() => {
  const financedProjectsSection = document.querySelector('.financedProjects');
  const FWP = window.FWP;
  if (financedProjectsSection) {
    FWP.auto_refresh = false;
  }
});
